// Số Zalo của trung tâm cho nút Zalo nổi trên LMS — null khi trung tâm chưa
// có số (nút bị ẩn thay vì dẫn tới zalo.me/undefined).
export function centerZaloNumber(center) {
  if (!center || typeof center !== 'object') return null;
  const value = String(center.zalo ?? '').trim();
  if (!value || value === 'undefined' || value === 'null') return null;
  return value;
}
